'use client';

export { RecentlyViewed } from './ui/recently-viewed';
